import React from "react";
import Home from "../../components/Home/Home"

export default function HomePage() {
    return (
        <div>
            <Home />
        </div>
    );
}
